<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model
        ref="form"
        :model="model"
        :rules="validatorRules"
        slot="detail"
      >
        <a-form-model-item
          label="产品代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="fundCode"
        >
          <a-select
            show-search
            v-model="model.fundCode"
            placeholder="请选择产品代码"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="value => handleSearch(value)"
            @change="value => handleChange(value)"
          >
            <a-select-option
              v-for="(item, index) in fundCodeList"
              :key="item.fundCode + '_' + index"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="起息日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="beginDate"
        >
          <a-date-picker
            v-model="model.beginDate"
            :disabled-date="disabledStartDate"
            format="YYYY-MM-DD "
            placeholder="请选择起息日"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="结息日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="endDate"
        >
          <a-date-picker
            placeholder="请选择结息日期"
            v-model="model.endDate"
            style="width: 100%"
            format="YYYY-MM-DD"
            :disabled-date="disabledEndDate"
          />
        </a-form-model-item>
        <a-form-model-item
          label="预期开放日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="openDate"
        >
          <j-date
            placeholder="请选择预期开放日"
            v-model="model.openDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="申购日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="purchaseDate"
        >
          <j-date
            placeholder="请选择申购日"
            v-model="model.purchaseDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="赎回日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="redemptionDate"
        >
          <j-date
            placeholder="请选择赎回日"
            v-model="model.redemptionDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="下一个申购日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="nextPurchaseDate"
        >
          <j-date
            placeholder="请选择下一个申购日"
            v-model="model.nextPurchaseDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="下一个赎回日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="nextRedemptionDate"
        >
          <j-date
            placeholder="请选择下一个赎回日"
            v-model="model.nextRedemptionDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="下一个开放日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="nextOpenDate"
        >
          <j-date
            placeholder="请选择下一个开放日"
            v-model="model.nextOpenDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="资金需求"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="fundDemand"
        >
          <a-input
            v-model="model.fundDemand"
            placeholder="请输入资金需求"
          ></a-input>
        </a-form-model-item>
        <a-form-item
          label="资金需求状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            type="list"
            v-model="model.fundDemandStatus"
            dictCode="fundDemandStatus"
            :placeholder="'请选择'"
          />
        </a-form-item>
        <a-form-model-item
          label="发行开始日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="issueBeginDate"
        >
          <j-date
            placeholder="请选择下一个开放日"
            v-model="model.issueBeginDate"
            style="width: 100%"
          />
          <!-- <j-date
            placeholder="请选择发行开始日"
            v-model="model.issueBeginDate"
            style="width: 100%"
          /> -->
        </a-form-model-item>
        <a-form-model-item
          label="发行截止日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="issueEndDate"
        >
          <j-date
            placeholder="请选择下一个开放日"
            v-model="model.issueEndDate"
            style="width: 100%"
          />
          <!-- <j-date
            placeholder="请选择发行截止日"
            v-model="model.issueEndDate"
            style="width: 100%"
          /> -->
        </a-form-model-item>
        <a-form-model-item
          label="发行天数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="issueNumber"
        >
          <a-input
            type="number"
            :min="1"
            v-model="model.issueNumber"
            placeholder="请输入发行天数"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item
          label="到期日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="dueDate"
        >
          <j-date
            placeholder="请选择到期日"
            v-model="model.dueDate"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="质押备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="pledgeNote"
        >
          <a-input
            v-model="model.pledgeNote"
            placeholder="请输入质押备注"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item
          label="收益率(%)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="expectedYield"
        >
          <a-input-number
            v-model="model.expectedYield"
            placeholder="请输入收益率"
          ></a-input-number>
        </a-form-model-item>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction, jsonAction } from '@/api/manage';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import moment from 'moment';

export default {
  name: 'ProductsQuotationForm',
  components: {
    JDate,
    JDictSelectTag
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {
        beginDate: null,
        endDate: null
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      channel: [],
      validatorRules: {
        fundCode: [{ required: true, message: '请输入产品代码!' }],
        beginDate: [{ required: true, message: '请输入起息日期!' }],
        endDate: [{ required: true, message: '请输入结息日期!' }],
        expectedYield: [{ required: true, message: '请输入收益率!' }],
        fundDemand: [
          {
            pattern: '^([\u4e00-\u9fa5]+|[a-zA-Z0-9]+)$',
            message: '请输入正确的资金值!'
          }
        ]
      },
      url: {
        add: process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/add',
        edit:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productQuotation/edit',
        queryById:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productQuotation/queryById',
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/all'
      },
      fundCodeList: [] //临时保存产品代码搜索后数据
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    }
  },
  created() {
    //备份model原始值
    this.channelList();
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
  },
  methods: {
    channelList() {
      let that = this;
      getAction(that.url.list, { isParent: 0 }).then(res => {
        if (res.success) {
          this.channel = res.result && res.result ? res.result : [];
          this.fundCodeList = this.channel;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    add() {
      this.model = {};
      // this.edit(this.modelDefault);
    },
    edit(record) {
      // record.issueBeginDate = moment(record.issueBeginDate).format(
      //   'YYYY-MM-DD'
      // );
      // record.issueEndDate = moment(record.issueEndDate).format('YYYY-MM-DD');
      this.model = Object.assign({}, record);
      this.visible = true;
      console.log(record, this.model);
    },
    disabledStartDate(startValue) {
      let endDate = this.model.endDate;
      console.log(endDate, '>>>');
      if (!startValue || !endDate) {
        return false;
      }
      return startValue > endDate;
    },
    disabledEndDate(endValue) {
      let startValue = this.model.beginDate;
      console.log(startValue, '>>>>');
      if (!endValue || !startValue) {
        return false;
      }
      return startValue >= endValue;
    },

    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          this.model.beginDate = moment(this.model.beginDate).format(
            'YYYY-MM-DD'
          );

          this.model.endDate = moment(this.model.endDate).format('YYYY-MM-DD');
          console.log(this.model, '当前数据信息');
          jsonAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    handleSearch(value) {
      let arr = [];
      this.channel.forEach(item => {
        if (
          item.fundCode.indexOf(value) > -1 ||
          item.fundName.indexOf(value) > -1
        ) {
          arr.push(item);
        }
      });
      this.fundCodeList = arr;
    },
    handleChange(value) {
      let str = value ? value.split('_')[0] : '';
      this.model.fundCode = str;
      this.channelList();
    }
  }
};
</script>
